




import Vue from "vue";
import { AreaType } from "throne-api";

export default Vue.extend({
  name: "components-vacancy-text",
  props: {
    vacantCount: { type: Number, required: true },
    totalCount: { type: Number, required: true },
    waitingSeconds: { type: Number, required: true },
    // NOTE: These 3 props below are for 3rd gen hardcoding
    placeId: { type: Number, required: false },
    status: { type: String, required: false },
    areaType: { type: String as () => AreaType, required: false },
  },
  computed: {
    vacancyText(): string {
      // NOTE: Hardcode for WAIM
      if (this.placeId === 110 || this.placeId === 240) {
        if (
          [
            "washing_machine",
            "washing_machine_male",
            "washing_machine_female",
            "dryer",
            "dryer_male",
            "dryer_female",
          ].includes(this.areaType)
        ) {
          if (this.status === "full" || this.status === "busy") {
            return "使用中";
          } else if (this.status === "notReady") {
            return "取り出し待ち";
          }
        }
      }

      if (this.vacantCount === 0) {
        if (this.waitingSeconds > 0) {
          return `${this.waitingSeconds / 60}分以上待ち`;
        }
        return "満室";
      } else if (this.vacantCount === 1 && this.totalCount !== 1) {
        if (this.waitingSeconds > 0) {
          return `${this.waitingSeconds / 60}分以上待ち`;
        }
        return "混雑";
      }
      return "空きあり";
    },
  },
});
